export default __webpack_public_path__ + "static/media/star.4a9814ad.png";